module.exports = __webpack_public_path__ + "img/500.54512987.png";